import {completeBundleHistoryByIdTqo} from "../../../rpc/webrpc-client.gen.ts";
import {JsonEditor} from "json-edit-react";
import {createFileRoute} from "@tanstack/react-router";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";
import {useRefreshableInfallibleQuery} from "../../../util/tqrefresh.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {useMothership} from "../../../tq/tqx.tsx";

interface HistoryBundleViewProps {
    bundleId: string;
}

function HistoryBundleView({bundleId}: HistoryBundleViewProps) {
    const mama = useMothership();
    const {data: history}
        = useRefreshableInfallibleQuery(completeBundleHistoryByIdTqo(mama, {bundleId}));
    if (!history) {
        return <SuspenseDialog message="fetching history"/>
    }
    return <JsonEditor data={history} restrictEdit={true}/>
}

function HistoryBundlePage() {
    const {id: bundleId} = Route.useParams();
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <HistoryBundleView bundleId={bundleId}/>
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/history/bundle/$id")({
    component: HistoryBundlePage,
});
